module.exports = __webpack_public_path__ + "img/feedbackimage.f641b459.svg";